// Pure domain logic for incoming shipments (no React, no store) — unit-testable.

// Statuses that show a "days left" countdown.
const COUNTDOWN_STATUSES = ['TO_RECEIVED', 'PARTIALLY_RECEIVED'];

/** Whether this row's status gets a countdown at all; the server computes the number. */
export const showsDaysLeft = (status) => COUNTDOWN_STATUSES.includes(status);
